import { render, staticRenderFns } from "./PhoSelect.vue?vue&type=template&id=7a125779&lang=pug"
import script from "./PhoSelect.vue?vue&type=script&lang=js"
export * from "./PhoSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports